import * as Sentry from '@sentry/nextjs';
import { useEffect } from 'react';

import ErrorMessage from '@/components/templates/ErrorMessage';

export default function Custom404() {
  useEffect(() => {
    const trackingError = async () => {
      const error = new Error('Page Not Found');
      await Sentry.captureException(error);
    };

    trackingError();
  }, []);

  return (
    <ErrorMessage
      errorCode="404"
      title="Sorry we couldn't find this page."
      description="But dont worry, you can find plenty of other things on our home
            page."
    />
  );
}
